var HashMap = require("../../collections/hashMap.js");

var ObservableTreeShadow = require("./observableTreeShadow.js");
var ObservableTreeCachedFunction = require("./observableTreeCachedFunction.js");
var ObservableTreeMap = require("./observableTreeMap.js");
var ObservableTreeSet = require("./observableTreeSet.js");
var ObservableTreeList = require("./observableTreeList.js");
var hash = require("../../hash.js");

var Shadows = {
    initShadows: function(){
        this.shadows = new HashMap();
    },

    shadow: function(name, getter, setter, triggers){
        console.assert(typeof name == "string" && !this.shadows.contains(name), 'Invalid shadow name: "' + name + '". A shadow with this name already exist or name is not a string');
        console.assert(arguments.length<=4, "Too many arguments to create shadow");
        
        var shadow = ObservableTreeShadow.createNewFunction(this, name, getter, setter, triggers);
        this.shadows.put(name, shadow);
        return shadow;
    },
    
    //treat a cached function as a special kind of shadow
    cachedFunction: function(name, fn, triggers, size){
        console.assert(typeof name == "string" && !this.shadows.contains(name), 'Invalid shadow name: "' + name + '". A shadow with this name already exist or name is not a string');

        var cachedFn = ObservableTreeCachedFunction.createNewFunction(this, name, fn, triggers, size);
        this.shadows.put(name, cachedFn);
        return cachedFn;
    },

    deepCachedFunction: function(name, fn, triggers, size){
        console.assert(typeof name == "string" && !this.shadows.contains(name), 'Invalid shadow name: "' + name + '". A shadow with this name already exist or name is not a string');

        var cachedFn = ObservableTreeCachedFunction.createNewFunction(this, name, fn, triggers, size, hash.deepObjectHash);
        this.shadows.put(name, cachedFn);
        return cachedFn;
    },


    shadowMap: function(name, owner, validate){ // TODO: allow key owner?
        console.assert(typeof name == "string" && !this.shadows.contains(name), 'Invalid shadow name: "' + name + '". A shadow with this name already exist or name is not a string');

        var shadowMap = new ObservableTreeMap(this, name, owner, validate);
        shadowMap.nonPersistent = true;
        this.shadows.put(name, shadowMap);
        return shadowMap;
    },

    shadowSet: function(name, owner, validate){
        console.assert(typeof name == "string" && !this.shadows.contains(name), 'Invalid shadow name: "' + name + '". A shadow with this name already exist or name is not a string');

        var shadowSet = new ObservableTreeSet(this, name, owner, validate);
        shadowSet.nonPersistent = true;     // TODO: not very clean: this only makes sure this is set is not made persistent hence not recorded, but adding elements to this shadowSet will resutl in new shadow bubbles, better would be if the original event bubbles through this shadow, same like real shadows.
        this.shadows.put(name, shadowSet);
        return shadowSet;
    },

    shadowList: function(name, owner, validate){
        console.assert(typeof name == "string" && !this.shadows.contains(name), 'Invalid shadow name: "' + name + '". A shadow with this name already exist or name is not a string');

        var shadowList = new ObservableTreeList(this, name, owner, validate);
        shadowList.nonPersistent = true;
        this.shadows.put(name, shadowList);
        return shadowList;
    }

};

module.exports = Shadows;
